export default __webpack_public_path__ + "static/media/bg_main.5bd738d7.jpg";